import { firstValueFrom } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { TuiInputModule } from '@taiga-ui/kit';
import { TuiButtonModule, TuiTextfieldControllerModule } from '@taiga-ui/core';
import { ActivatedRoute } from '@angular/router';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Component, inject, Input, OnInit } from '@angular/core';

import { MobileAuthService } from '../mobile-auth.service';
import { AuthContext } from '../auth.helpers';

import { COOKIE_EMAIL_KEY, MOBILE_EMAIL_KEY } from './resolve-auth-email';

import { environment } from '@wo-environments';
import { FileHashPipe } from '@iss/wo-common/hash-files';
import { Maybe } from '@iss/libs/graphql';
import { FormFieldComponent, LabelDirective } from '@iss/core/forms';

@Component({
  templateUrl: './login.component.html',
  styleUrls: [ './login.component.scss' ],
  standalone: true,
  imports: [
    FileHashPipe,
    FormFieldComponent,
    LabelDirective,
    ReactiveFormsModule,
    TuiInputModule,
    TuiTextfieldControllerModule,
    TuiButtonModule,
  ],
  providers: [
    CookieService,
  ],
})
export class LoginComponent implements OnInit {
  private readonly cookie = inject(CookieService);
  private readonly mobile = inject(MobileAuthService);
  private readonly route = inject(ActivatedRoute);
  public readonly appName = environment.appName;
  public control!: FormControl<string>;

  @Input() email: Maybe<string>;

  public ngOnInit(): void {
    this.control = new FormControl<string>(AuthContext.getEmail() || this.email || '', {
      validators: [ Validators.required, Validators.email ],
      nonNullable: true,
    });
  }

  public async onContinue(): Promise<void> {
    this.control.markAsTouched();

    if (this.control.invalid) {
      return;
    }

    await this.persistEmail(this.control.value);
    window.location.href = this.route.snapshot.queryParamMap.get('redirect') || '/';
  }

  private persistEmail(email: string): Promise<unknown> {
    AuthContext.setEmail(email);
    this.cookie.set(COOKIE_EMAIL_KEY, email);
    return firstValueFrom(this.mobile.store(MOBILE_EMAIL_KEY, email));
  }
}
